import { baseApiUrl } from 'src/config';
import { getAccessToken } from 'src/routes/AuthContext';

export const getUploadFilesizeLimit = async (
  realm: string,
  facilityId: string
): Promise<number> => {
  const token = await getAccessToken();
  const defaultLimit = 250 * 1024 * 1024;

  return fetch(`${baseApiUrl}/provider/document/file-size-limits`, {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${token}`,
      'x-tenant-id': realm,
      'facility-id': facilityId,
    },
  })
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      } else {
        throw new Error(`${response.status}`);
      }
    })
    .then((response) => {
      if (response.data.maxRequestSize) {
        return response.data?.maxRequestSize || defaultLimit;
      } else {
        throw new Error('Malformed response');
      }
    })
    .catch((error) => {
      console.error(`Error fetching form fields: ${error}. Using default of ${defaultLimit}`);
      return defaultLimit;
    });
};
